import { OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { TreeViewService } from './fc-tree-view.service';
import { ActionTypeEnum } from './fc-tree.types';
var TreeViewComponent = /** @class */ (function () {
    function TreeViewComponent(treeViewService) {
        this.treeViewService = treeViewService;
        this.destroy$ = new Subject();
    }
    TreeViewComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.level = this.level || 0;
        this.treeViewService.checked$.pipe(takeUntil(this.destroy$)).subscribe(function (params) {
            _this.propagateSelection(params);
        });
    };
    TreeViewComponent.prototype.ngOnDestroy = function () {
        this.destroy$.next();
        this.destroy$.complete();
    };
    TreeViewComponent.prototype.onCheckboxChange = function ($event) {
        if (this.item.action.type !== ActionTypeEnum.checkbox) {
            return;
        }
        this.item.action.checked = $event.checked;
        this.propagateSelection(this.item);
        this.treeViewService.checked$.next(this.item);
    };
    TreeViewComponent.prototype.propagateSelection = function (item) {
        var _this = this;
        if (!this.item.id ||
            item.id === this.item.id ||
            item.action.type !== ActionTypeEnum.checkbox ||
            this.item.action.type !== ActionTypeEnum.checkbox) {
            return;
        }
        if (item.action.checked && (item.parent && item.parent.id === this.item.id) || this.item.children.some(function (child) { return item.parent && child.id === item.parent.id; })) {
            this.item.action.checked = true;
            return;
        }
        if (!item.action.checked && item.children.some(function (child) { return child.id === _this.item.id || (_this.item.parent && child.id === _this.item.parent.id); })) {
            this.item.action.checked = false;
        }
    };
    return TreeViewComponent;
}());
export { TreeViewComponent };
